import { createTheme, type MantineColorsTuple } from '@mantine/core';

const purple: MantineColorsTuple = [
  '#eee7ff',
  '#cabafc',
  '#a78df3',
  '#8460ed',
  '#6032e6',
  '#4719cd',
  '#3712a0',
  '#260d74',
  '#170747',
  '#09011d',
];

const yellow: MantineColorsTuple = [
  '#fff7dd',
  '#fce8b3',
  '#f8d886',
  '#f5c856',
  '#f2b929',
  '#d99f11',
  '#a97c0a',
  '#785904',
  '#493500',
  '#1b1200',
];

const orange: MantineColorsTuple = [
  '#ffebe1',
  '#fbccb8',
  '#f2ab8d',
  '#ea8b61',
  '#e36935',
  '#ca501c',
  '#9e3d15',
  '#712b0d',
  '#451904',
  '#1d0500',
];

const teal: MantineColorsTuple = [
  '#e1f8ff',
  '#bee4f1',
  '#9ad1e4',
  '#75bfd9',
  '#50accd',
  '#3993b4',
  '#29728c',
  '#1b5265',
  '#09313f',
  '#001219',
];

const green: MantineColorsTuple = [
  '#e3fcec',
  '#bfefd1',
  '#9be3b5',
  '#74d899',
  '#4ecc7d',
  '#36b364',
  '#278b4d',
  '#1a6336',
  '#0b3d1f',
  '#001605',
];

const red: MantineColorsTuple = [
  '#ffe2e2',
  '#ffb1b2',
  '#ff7f7f',
  '#ff4d4d',
  '#fe1d1b',
  '#e50501',
  '#b30000',
  '#810000',
  '#4f0000',
  '#200000',
];

const blue: MantineColorsTuple = [
  '#e5ebff',
  '#b6c2fe',
  '#8699f8',
  '#5770f5',
  '#2a47f1',
  '#142fd7',
  '#0c23a8',
  '#071979',
  '#020f4a',
  '#00051d',
];

const dark: MantineColorsTuple = [
  '#EFEFEF',
  '#D9D9D9',
  '#BFBFBF',
  '#A6A6A6',
  '#8C8C8C',
  '#737373',
  '#595959',
  '#404040',
  '#262626',
  '#000000',
];

export const theme = createTheme({
  colors: {
    purple,
    yellow,
    orange,
    teal,
    green,
    red,
    blue,
    dark,
  },
  primaryColor: 'purple',
  primaryShade: { light: 5, dark: 7 },
  
  fontFamily: '"Inter Tight", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  fontFamilyMonospace: 'Monaco, Courier, monospace',
  headings: { fontFamily: '"Inter Tight", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },

  defaultRadius: 'md',
  
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
      },
    },
    Input: {
      defaultProps: {
        size: 'sm',
      },
    },
    Select: {
      defaultProps: {
        size: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    Table: {
      defaultProps: {
        highlightOnHover: true,
        withTableBorder: true,
        verticalSpacing: 'sm',
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
      },
    },
    Loader: {
      defaultProps: {
        type: 'bars',
      },
    },
  },
  
  breakpoints: {
    xs: '30em',
    sm: '48em',
    md: '64em',
    lg: '74em',
    xl: '90em',
  },
});